import { cartMoney, cartNumber } from './cartItem';

type CouponResult = { valid: boolean; discount: string; message?: string };

// O mínimo sempre se refere ao subtotal dos produtos; a base percentual pode
// incluir a entrega, conforme o cadastro já utilizado pelo carrinho.
export function evaluateCartCoupon(coupons: any[], code: string,
  productsSubtotal: any, delivery: any): CouponResult {
  const coupon = (Array.isArray(coupons) ? coupons : []).find(item => item.nome === code);
  if (!coupon) return { valid: false, discount: '', message: 'Este cupom não está mais disponível.' };
  const subtotal = cartNumber(productsSubtotal);
  const minimum = cartNumber(coupon.valorMinimo);
  if (subtotal < minimum) return { valid: false, discount: '',
    message: `Este cupom exige pelo menos R$ ${cartMoney(minimum)} em produtos.` };
  const base = subtotal + (coupon.baseDesconto === 'total' ? cartNumber(delivery) : 0);
  const discount = (coupon.tipoDesconto || 'fixo') === 'percentual'
    ? Math.round(base * cartNumber(coupon.valor)) / 100 : cartNumber(coupon.valor);
  return { valid: true, discount: cartMoney(discount) };
}

export function validateCheckoutCoupon(coupons: any[], code: string | undefined,
  discount: any, productsSubtotal: any, delivery: any): CouponResult {
  if (!code && !cartNumber(discount)) return { valid: true, discount: '' };
  if (code) {
    const selected = evaluateCartCoupon(coupons, code, productsSubtotal, delivery);
    if (!selected.valid) return selected;
    if (cartNumber(discount) === cartNumber(selected.discount)) return selected;
    return { valid: false, discount: selected.discount,
      message: 'O desconto do cupom mudou. Revise o total antes de continuar.' };
  }
  // Compatibilidade com telas antigas que recebiam só o desconto monetário.
  const matches = (Array.isArray(coupons) ? coupons : []).map(coupon =>
    evaluateCartCoupon(coupons, coupon.nome, productsSubtotal, delivery));
  const match = matches.find(result => result.valid && cartNumber(result.discount) === cartNumber(discount));
  return match || { valid: false, discount: '', message: 'Cupom inválido para este pedido. Revise o carrinho.' };
}
